import { render, staticRenderFns } from "./SubscribeWaitlistLandingPage.vue?vue&type=template&id=f147c852&"
import script from "./SubscribeWaitlistLandingPage.vue?vue&type=script&lang=js&"
export * from "./SubscribeWaitlistLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports